import { Image } from 'antd'
import { motion } from 'framer-motion'
import { PostDTO } from '../../../api/dto'

type Props = {
    post: PostDTO
    onClick: () => void
    index: number
    onLoad: () => void
    finishedLoading: boolean
}

export default function ContestantCard({ post, onClick, index, onLoad, finishedLoading }: Props) {
    const variants = {
        waiting: {
            opacity: 0
        },
        loaded: {
            opacity: 1,
            transition: {
                delay: index * 0.11,
                easings: ['easeInOut', 'easeOut'],
                bounce: 0.5
            }
        }
    }

    return (
        <motion.div
            variants={variants}
            initial="waiting"
            animate={finishedLoading ? 'loaded' : 'waiting'}
            className="group relative aspect-square w-full cursor-pointer"
            whileHover={{ scale: 1.05 }}
            onClick={onClick}
            style={{
                width: '100%',
                height: '100%'
            }}
        >
            <Image
                src={post.image_url}
                alt="avatarImage"
                preview={false}
                className="h-full w-full rounded-lg object-cover shadow-lg "
                onLoad={onLoad}
            />
        </motion.div>
    )
}
